// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__7X3tf","description":"styles_description__I6hDV","header":"styles_header__g59i_"};